import { Config } from '../services/config/config.service';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FxRatesClient {
  public endpoint: string;

  constructor(public http: HttpClient, public _config: Config) {
    this.endpoint = _config.CONFIG.apiUrl + '/fx_rates';
  }

  get(): Observable<any> {
    return this.http.get(this.endpoint)
      .pipe(
        map(data => data),
        catchError(err => throwError(err))
      );
  }
}
